/* istanbul ignore file */
import {CustomCssVarsFn} from '@wix/yoshi-flow-editor';
import {baseCustomCssVars, CustomCssVarsFnParams} from '../../baseCustomCssVars';
import {createStylesParams, StyleParamType} from '@wix/tpa-settings';
import {baseStylesParams, galleryColumnsDefaultValue} from '../../styleParams/baseStylesParams';
import {IStylesParams, StylesParamKeys} from '../../styleParams/types';

export const customCssVars: CustomCssVarsFn = (params: CustomCssVarsFnParams) => {
  return {
    ...baseCustomCssVars(params),
  };
};

const stylesParams: IStylesParams = {
  ...baseStylesParams,
  galleryColumns: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: galleryColumnsDefaultValue,
  },
  gallery_layoutVerticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
};

export default createStylesParams<StylesParamKeys>(stylesParams);
